var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons8-telegram-app",
    transform: "translate(3.000000, 5.000000)",
    fill: "#707E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.1378089,0.549881452 C42.3878089,-0.0861185481 41.2098089,-0.177118548 39.9918089,0.311881452 L39.9898089,0.311881452 C38.7088089,0.825881452 3.72880887,15.8298815 2.30480887,16.4428815 C2.04580887,16.5328815 -0.216191133,17.3768815 0.0168088665,19.2568815 C0.224808867,20.9518815 2.04280887,21.6538815 2.26480887,21.7348815 L11.1578089,24.7798815 C11.7478089,26.7438815 13.9228089,33.9898815 14.4038089,35.5378815 C14.7038089,36.5028815 15.1928089,37.7708815 16.0498089,38.0318815 C16.8018089,38.3218815 17.5498089,38.0568815 18.0338089,37.6768815 L23.4708089,32.6338815 L32.2478089,39.4788815 L32.4568089,39.6038815 C33.0528089,39.8678815 33.6238089,39.9998815 34.1688089,39.9998815 C34.5898089,39.9998815 34.9938089,39.9208815 35.3798089,39.7628815 C36.6948089,39.2228815 37.2208089,37.9698815 37.2758089,37.8278815 L43.8318089,3.75088145 C44.2318089,1.93088145 43.6758089,1.00488145 43.1378089,0.549881452 Z M19.0008089,25.9978815 L16.0008089,33.9978815 L13.0008089,23.9978815 L36.0008089,6.99788145 L19.0008089,25.9978815 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.c857a2eb85897114629c075f6640c495.svg";
export { ForwardRef as ReactComponent };